/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-danger */
import React from "react";
import { SearchPageResult } from "./SearchPageResult";
import RelatedSearchTerms from "./RelatedSearchTerms";
import SearchCategoriesView from "./SearchBrandsCategoriesView";
import FiltersAreSelected from "../FiltersAreSelected";
import { getSortByValueFromUrl } from "../Toolbar/SortByHelpers";
interface Props {
  detail: SearchPageResult;
}
const SearchPageWithResultsView = ({
  detail
}: Props) => {
  const hasMatch = detail.hasSearchValue && detail.bestSearchGuessTerms && detail.bestSearchGuessTerms.numberOfMatches > 0;
  const hasPageHeader = detail.pageHeader && detail.pageHeader.length > 0;
  const showSearchCategoriesView = detail.pagination.currentPage === 1 && (!!detail.categories?.length || !!detail.brands?.length) && !FiltersAreSelected(detail.facetNavigation) && !getSortByValueFromUrl(detail.originalUrl);
  const pageHeader = detail.pagination.totalNumberOfItems === 1 ? detail.pageHeader.replace("Showing results", "Showing 1 result") : detail.pageHeader.replace("Showing", `Showing ${detail.pagination.totalNumberOfItems.toLocaleString()}`);
  const pageHeaderWithSuggestion = detail.bestSearchGuessTerms ? pageHeader.replace(detail.bestSearchGuessTerms.originalTerm, detail.bestSearchGuessTerms.suggestTerm) : pageHeader;
  const isSearchTermAutoCorrected = detail.bestSearchGuessTerms?.originalTerm !== detail.bestSearchGuessTerms?.suggestTerm && !detail.bestSearchGuessTerms?.altDisplayTerm;
  const altDisplayTerm = `"${detail.bestSearchGuessTerms?.altDisplayTerm}"`;
  const HeaderWithDefaultMeta = () => <>
      <h1 className="page-header search--title text-xl" dangerouslySetInnerHTML={{
      __html: pageHeaderWithSuggestion
    }} />{" "}
      {detail.bestSearchGuessTerms?.altDisplayTerm && <span className="block text-lg">
          Search instead for{" "}
          <a className="font-semibold" href={`/search/${detail.bestSearchGuessTerms?.altTerm}.html`} dangerouslySetInnerHTML={{
        __html: altDisplayTerm
      }} />
        </span>}
      {isSearchTermAutoCorrected && <div className="block text-lg">
          There are no search results for &quot;
          {detail.bestSearchGuessTerms?.originalTerm}&quot;
        </div>}
    </>;
  return <>
      <div className="search__wrap">
        {hasMatch && hasPageHeader && detail.hasDefaultCustomMeta && <HeaderWithDefaultMeta />}

        {hasMatch && hasPageHeader && !detail.hasDefaultCustomMeta && <div className="page-header search--title">
            {detail.pagination.totalNumberOfItems === 1 ? `1 Result for ` : `${detail.pagination.totalNumberOfItems.toLocaleString()} Results for `}
            <h1 className="page-header search--title" dangerouslySetInnerHTML={{
          __html: detail.pageHeader
        }} />
          </div>}
        {detail.pagination.currentPage === 1 && detail.relatedSearchTerms && detail.relatedSearchTerms.length > 0 && <RelatedSearchTerms relatedSearchTerms={detail.relatedSearchTerms} />}
      </div>
      <div id="search-page" className="search--wrap overflow">
        {showSearchCategoriesView && <SearchCategoriesView brands={detail.brands} categories={detail.categories} resources={detail.resources} promotedCategory={detail.promotedCategoryBrandAd} />}
      </div>
    </>;
};
export default SearchPageWithResultsView;